import { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import {
  HomeIcon,
  XMarkIcon,
  BuildingOffice2Icon,
  PaintBrushIcon,
  ClipboardDocumentCheckIcon,
} from "@heroicons/react/24/outline";
import { useNavigate, NavLink } from "react-router-dom";
import { useNCallContext } from "../context/ncall-context";
import ReportList from "./reports/reportsList";

const navigation = [
  { name: "Dashboard", to: "/client", icon: HomeIcon, current: true },
  {
    name: "Schedules",
    to: "/client/schedules",
    icon: ClipboardDocumentCheckIcon,
    current: true,
  },

  // {
  //   name: "Reports",
  //   to: "/client/schedules",
  //   icon: ChartPieIcon,
  //   current: true,
  // },
];

const adminnav = [
  { name: "Clients", to: "/admin", icon: BuildingOffice2Icon, current: true },
  {
    name: "Ncal status colors",
    to: "/admin/colors",
    icon: PaintBrushIcon,
    current: true,
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Sidebar = () => {
  const {
    openSideBar,
    setOpenSideBar,
    APP_RESET,
    state,
    getReports,
    getDepartments,
  } = useNCallContext();
  const navigate = useNavigate();

  const currentPath = window.location.pathname;

  const segments = currentPath.split("/");
  let lastSegment = segments.pop();

  const [activeLink, setActiveLink] = useState(
    "/" + lastSegment || lastSegment
  );

  const loggedInAs = localStorage.getItem("logged-in-as");

  let _navigation;

  loggedInAs === "admin"
    ? (_navigation = adminnav)
    : (_navigation = navigation);

  const handleCloseClient = () => {
    localStorage.removeItem("code");
    localStorage.removeItem("scheduler");
    localStorage.removeItem("companyName");
    localStorage.removeItem("clientId");
    localStorage.removeItem("companyId");

    localStorage.removeItem("logged-in-as");

    // Reset State
    APP_RESET();

    navigate("/");
  };

  useEffect(() => {
    getReports();
    getDepartments();
  }, []);

  return (
    <>
      <Transition.Root show={openSideBar} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-40 md:hidden"
          onClose={setOpenSideBar}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
          </Transition.Child>

          <div className="fixed inset-0 z-40 flex">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative flex w-full max-w-xs flex-1 flex-col bg-indigo-700">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute top-0 right-0 -mr-12 pt-2">
                    <button
                      type="button"
                      className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                      onClick={() => setOpenSideBar(false)}
                    >
                      <span className="sr-only">Close sidebar</span>
                      <XMarkIcon
                        className="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </Transition.Child>
                <div className="h-0 flex-1 overflow-y-auto pt-5 pb-4">
                  <div className="flex flex-shrink-0 items-center px-4">
                    <h1 className="text-white">
                      {loggedInAs === "client" ? (
                        <span>{localStorage.getItem("companyName")}</span>
                      ) : (
                        <span>Admin</span>
                      )}
                    </h1>
                  </div>
                  <nav className="mt-5 space-y-1 px-2">
                    {_navigation.map((item) =>
                      loggedInAs === "admin" ? (
                        <NavLink
                          key={item.name + "mobile"}
                          to={item.to}
                          onClick={() => setActiveLink(item.to)}
                          className={classNames(
                            activeLink === item.to
                              ? "bg-indigo-800 text-white"
                              : "text-white hover:bg-indigo-600 hover:bg-opacity-75",
                            "group flex items-center px-2 py-2 text-base font-medium rounded-md"
                          )}
                        >
                          <item.icon
                            className="mr-4 h-6 w-6 flex-shrink-0 text-indigo-300"
                            aria-hidden="true"
                          />
                          {item.name}
                        </NavLink>
                      ) : state.departments.length === 0 &&
                        item.name === "Schedules" ? (
                        ""
                      ) : (
                        <NavLink
                          key={item.name + "mobile"}
                          to={item.to}
                          onClick={() => setActiveLink(item.to)}
                          className={classNames(
                            activeLink === item.to
                              ? "bg-indigo-800 text-white"
                              : "text-white hover:bg-indigo-600 hover:bg-opacity-75",
                            "group flex items-center px-2 py-2 text-base font-medium rounded-md"
                          )}
                        >
                          <item.icon
                            className="mr-4 h-6 w-6 flex-shrink-0 text-indigo-300"
                            aria-hidden="true"
                          />
                          {item.name}
                        </NavLink>
                      )
                    )}
                    {state.reports.length > 0 && loggedInAs === "client" && (
                      <ReportList />
                    )}
                  </nav>
                </div>
                <div className="flex flex-shrink-0 border-t border-indigo-800 p-4">
                  <button
                    onClick={handleCloseClient}
                    type="button"
                    className="inline-flex rounded-md bg-white/10 px-3.5 py-1.5 text-base font-semibold leading-7 text-white shadow-sm hover:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                  >
                    Close Client
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
            <div className="w-14 flex-shrink-0" aria-hidden="true">
              {/* Force sidebar to shrink to fit close icon */}
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      <div className="hidden md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col">
        {/* Sidebar component, swap this element with another sidebar if you like */}
        <div className="flex min-h-0 flex-1 flex-col bg-indigo-700">
          <div className="flex flex-1 flex-col overflow-y-auto pt-5 pb-4">
            <div className="flex flex-shrink-0 items-center px-4">
              <h1 className="text-white text-lg font-bold">
                {loggedInAs === "client" ? (
                  <span>{localStorage.getItem("companyName")}</span>
                ) : (
                  <span>Admin</span>
                )}
              </h1>
            </div>
            {/* <nav className="mt-5 flex-1 space-y-1 px-2">
              {_navigation.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.to}
                  onClick={() => setActiveLink(item.to)}
                  className={classNames(
                    activeLink === item.to
                      ? "bg-indigo-800 text-white"
                      : "text-white hover:bg-indigo-600 hover:bg-opacity-75",
                    "group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                  )}
                >
                  <item.icon
                    className="mr-3 h-6 w-6 flex-shrink-0 text-indigo-300"
                    aria-hidden="true"
                  />
                  {item.name}
                </NavLink>
              ))}
              {state.reports.length > 0 && loggedInAs === "client" ? (
                <ReportList />
              ) : (
                ""
              )}
            </nav> */}
            <nav className="mt-5 space-y-1 px-2">
              {_navigation.map((item) =>
                loggedInAs === "admin" ? (
                  <NavLink
                    key={item.name + "mobile"}
                    to={item.to}
                    onClick={() => setActiveLink(item.to)}
                    className={classNames(
                      activeLink === item.to
                        ? "bg-indigo-800 text-white"
                        : "text-white hover:bg-indigo-600 hover:bg-opacity-75",
                      "group flex items-center px-2 py-2 text-base font-medium rounded-md"
                    )}
                  >
                    <item.icon
                      className="mr-4 h-6 w-6 flex-shrink-0 text-indigo-300"
                      aria-hidden="true"
                    />
                    {item.name}
                  </NavLink>
                ) : state.departments.length === 0 &&
                  item.name === "Schedules" ? (
                  ""
                ) : (
                  <NavLink
                    key={item.name + "mobile"}
                    to={item.to}
                    onClick={() => setActiveLink(item.to)}
                    className={classNames(
                      activeLink === item.to
                        ? "bg-indigo-800 text-white"
                        : "text-white hover:bg-indigo-600 hover:bg-opacity-75",
                      "group flex items-center px-2 py-2 text-base font-medium rounded-md"
                    )}
                  >
                    <item.icon
                      className="mr-4 h-6 w-6 flex-shrink-0 text-indigo-300"
                      aria-hidden="true"
                    />
                    {item.name}
                  </NavLink>
                )
              )}
              {state.reports.length > 0 && loggedInAs === "client" && (
                <ReportList />
              )}
            </nav>
          </div>
          <div className="flex flex-shrink-0 border-t border-indigo-800 p-4">
            <button
              onClick={handleCloseClient}
              type="button"
              className="inline-flex rounded-md bg-white/10 px-3.5 py-1.5 text-base font-semibold leading-7 text-white shadow-sm hover:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            >
              {loggedInAs === "admin" ? (
                <span>Logout</span>
              ) : (
                <span> Close Client</span>
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
